// @flow
import styled from 'styled-components';
import { media } from '~/core/utils/style';

export const StyledButton = styled.button`
    background-color: ${({ alternate, disabled, theme }) =>
        disabled ? theme.mediumGrey : alternate ? theme.white : theme.mainBrandColor};
    border-radius: 2.5rem;
    border: 2px solid ${({ disabled, theme }) => (disabled ? theme.mediumGrey : theme.mainBrandColor)};
    cursor: ${({ disabled, theme }) => (disabled ? 'default' : 'pointer')};
    color: ${({ alternate, disabled, theme }) => (!alternate || disabled ? theme.white : theme.grey)};
    font-size: 1rem;
    outline: none;
    padding: 0.75rem 3rem;
    position: relative;
    transition: background-color 0.3s, border-color 0.3s, color 0.3s;

    &:focus,
    &:hover {
        ${({ disabled, theme }) =>
            !disabled ? `background-color: ${theme.primaryBtnColors.hover}; color: ${theme.white};` : null};
    }
`;

export const RHSButtonContainer = styled.div`
    margin: 0 0 2em;
    min-width: 20em;
    text-align: center;
    ${media.tablet`
      float: right;
      margin: 0 0 0 2em;
      min-width: 0;
    `};
`;



// WEBPACK FOOTER //
// ./src/components/widgets/buttons/button/styles.js